import Vue from 'vue';
import differenceInDays from 'date-fns/differenceInDays';
import CloseIcon from '@/assets/svg/close.vue.svg';
import { LINK_TO_MOBILE_APP } from '@/constants/common';

export default (tooltipName: string) =>
  Vue.extend<
    { link: string; isClosed: boolean },
    { handleClose(): void; sendEvent(): void },
    { previousClosingDate?: Date; isVisible: boolean }
  >({
    name: 'MobileAppBannerMixin',
    components: {
      CloseIcon,
    },
    data() {
      return {
        link: LINK_TO_MOBILE_APP,
        isClosed: false,
      };
    },
    computed: {
      previousClosingDate() {
        const closedDateString = localStorage.getItem(tooltipName);

        if (!closedDateString) return undefined;

        return new Date(closedDateString);
      },
      isVisible() {
        if (process.server || this.isClosed) return false;
        if (this.$auth.user && this.$auth.user.hasInstalledMobileApp) return false;
        if (this.$auth.user && this.$tooltip.isPresent(tooltipName)) return false;

        if (!this.previousClosingDate) return true;

        return differenceInDays(new Date(), this.previousClosingDate) > 6;
      },
    },
    methods: {
      handleClose() {
        this.$analytics.logEvent(`war-room__post-feed__${tooltipName}-close-button__click`);

        this.isClosed = true;

        if (this.$auth.user && this.previousClosingDate) {
          this.$tooltip.close(tooltipName);
        }

        localStorage.setItem(tooltipName, new Date().toISOString());
      },
      sendEvent() {
        this.$analytics.logEvent(`war-room__post-feed__${tooltipName}__click`);
      },
    },
  });
